import select from 'dom-select'

export default el => {
  const selectors = {
    mobileContainer: '[js-pages-menu="mobile"]',
    mobileTrigger: '[js-pages-menu="mobileTrigger"]'
  }

  const mobileTrigger = select.all(selectors.mobileTrigger, el)
  const mobileContainer = select(selectors.mobileContainer, el)

  mobileTrigger.forEach(trigger => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault()

      if (mobileContainer) {
        mobileContainer.classList.toggle('is-active')
        el.classList.toggle('z9')
      }
    })
  })
}
